import { DateTime } from "luxon";
import { useMemo } from "react";

const TWO_WEEKS_DAYS = 14;
const ONE_WEEK_DAYS = 7;

type ReminderLevel = "none" | "warning" | "urgent";

interface SchedulePublishReminder {
	level: ReminderLevel;
	daysRemaining: number | null;
}

/**
 * Calculates reminder state based on how close the staffScheduleDisplayUntilDate is to today.
 * - "warning" (red dot): display until date is within 2 weeks
 * - "urgent" (popup + red dot): display until date is within 1 week
 * - "none": more than 2 weeks away or no date set
 */
export const useSchedulePublishReminder = (displayUntilDate: DateTime | undefined | null): SchedulePublishReminder => {
	return useMemo(() => {
		if (!displayUntilDate) {
			return { level: "none", daysRemaining: null };
		}

		const now = DateTime.now().startOf("day");
		const target = displayUntilDate.startOf("day");
		const daysRemaining = Math.ceil(target.diff(now, "days").days);

		if (daysRemaining <= ONE_WEEK_DAYS) {
			return { level: "urgent", daysRemaining };
		}
		if (daysRemaining <= TWO_WEEKS_DAYS) {
			return { level: "warning", daysRemaining };
		}

		return { level: "none", daysRemaining };
	}, [displayUntilDate]);
};
